"use strict";
exports.__esModule = true;
exports.OrgStatus = void 0;
var OrgStatus;
(function (OrgStatus) {
    OrgStatus["FREE"] = "free";
    OrgStatus["FREE_TRIAL"] = "free_trial";
    OrgStatus["PRO"] = "pro";
    OrgStatus["BUSINESS"] = "business";
    OrgStatus["ENTERPRISE"] = "enterprise";
    OrgStatus["SUSPENDED"] = "suspended";
})(OrgStatus = exports.OrgStatus || (exports.OrgStatus = {}));
